<template lang="pug">
  //- 名刺人物の選択
  app-modal(type="default", size="large", v-model="value.isOpen", data-testid="sel-person-modal")
    template(slot="title") 名刺人物の選択

    .modal-layout
      .modal-side
        div(@keypress.enter.prevent="search")
          .form-group
            label.control-label 氏名（漢字・よみがな）
            input.form-control(type='text' v-model="search_name" :maxlength="maxlengths.search_name", autocomplete="nope" data-testid="-input-name-search")
          .form-group
            .radio.radio-rich
              label.radio-inline
                input(type="radio", v-model="nameSearchFilter", value="0")
                span: i.fa.fa-dot-circle-o.fa-lg
                | 前方一致
              label.radio-inline
                input(type="radio", v-model="nameSearchFilter", value="2")
                span: i.fa.fa-dot-circle-o.fa-lg
                | 部分一致
          .form-group
            .radio.radio-rich
              label.radio-inline
                input(type="radio", v-model="nameSearchFilter", value="1")
                span: i.fa.fa-dot-circle-o.fa-lg
                | 完全一致
          .form-group
            label.control-label 会社名（漢字・よみがな）
            input.form-control(type='text' placeholder="部分一致で検索します" title="会社名、会社名（よみがな）を部分一致で検索します" v-model="search_corporate_name" :maxlength="maxlengths.search_corporate_name", autocomplete="nope")
          .form-group
            label.control-label 最新名刺交換日
            .input-group.input-group-md
              date-picker.form-control(v-model="search_date_from")
              span.input-group-addon ～
              date-picker.form-control(v-model="search_date_to")
          button.btn.btn-primary(type="button" @click.prevent="search" data-testid="-btn-search") 検索

      .modal-layout-divider

      .modal-main
        .modal-list-target
          app-pagination(v-if="list.length > 0", :is-loading="loadingPagination", :pagination="pagination", :use-scroll-top="false", @change="getList")

          table.table.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  a(v-if="maxSelect === 100000", href='#', title='すべて追加', @click.prevent="apendAll")
                    i.fa.fa-fw.fa-angle-double-down
                th 名称

          loading(v-if="loading", :height="170")

          .table-responsive(v-else-if="list.length")
            table.table.table-bordered.bcard-table
              tbody
                tr(v-for="item in list", :key="item.id", :class="{active: isChecked(item.id)}")
                  td.bcard-table-td-chk
                    a(href='#', title='追加', @click.prevent="checkItem(item.id, true)")
                      i.fa.fa-fw.fa-arrow-down
                  td.bcard-table-td-fullname.bcard-ui-userdata
                    a(href='#', :title="item.full_name", @click.prevent="openModalBcard(item.id)")
                      i.fa.bcard-fa-person-private(v-if="item.openflag === app_flag.OFF" title="非公開")
                      |
                      | {{item.full_name}}
                  td.bcard-table-td-company.bcard-ui-userdata(:title="item.corporate_name") {{item.corporate_name}}
                  td.bcard-table-td-groups.bcard-ui-userdata(:title="item.dept") {{item.dept}}
                  td.bcard-table-td-post.bcard-ui-userdata(:title="item.post") {{item.post}}
                  td.bcard-table-td-ymd {{item.formatted_exdate}}

          app-messages(
            v-if="list.length === 0",
            :alignCenter="true",
            :errorMessages="modalErrors",
            :defaultMessages="modalMessages"
          )

        .modal-list-divider

        .modal-list-selected
          table.table.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  a(href='#', title='すべての選択を解除', @click.prevent="checkAll(list, false)")
                    i.fa.fa-fw.fa-times
                th 名称
          .table-responsive
            table.table.table-bordered.bcard-table
              tbody
                tr(v-for="item in checkedItems", :key="item.id")
                  td.bcard-table-td-chk
                    a(href='#', title='解除', @click.prevent="checkItem(item.id, false)")
                      i.fa.fa-fw.fa-times
                  td.bcard-table-td-fullname.bcard-ui-userdata
                    a(href='#', :title="item.full_name", @click.prevent="openModalBcard(item.id)")
                      i.fa.bcard-fa-person-private(v-if="item.openflag === app_flag.OFF" title="非公開")
                      |
                      | {{item.full_name}}
                  td.bcard-table-td-company.bcard-ui-userdata(:title="item.corporate_name") {{item.corporate_name}}
                  td.bcard-table-td-groups.bcard-ui-userdata(:title="item.dept") {{item.dept}}
                  td.bcard-table-td-post.bcard-ui-userdata(:title="item.post") {{item.post}}
                  td.bcard-table-td-ymd {{item.formatted_exdate}}

    template(slot="footer", slot-scope="{close}")
      button.btn.btn-primary(type="button", @click="selectAndClose", data-testid="-btn-ok") OK
      button.btn.btn-default(type="button", @click="close" data-testid="-btn-cancel") キャンセル

    //- 最新の名刺情報モーダル
    modal-bcard(v-model="modalBcard")
</template>

<script>
import mixinList from '@/mixins/innerList'
import AppMessages from '@/components/molecules/AppMessages'
import AppModal from '@/components/templates/AppModal'
import DatePicker from '@/components/molecules/DatePicker'
import AppPagination from '@/components/molecules/AppPagination'
import ModalBcard from '@/components/organisms/ModalBcard'
import Loading from '@/components/molecules/Loading'

export default {
  name: 'ModalSelPerson',
  components: { AppMessages, AppModal, DatePicker, AppPagination, ModalBcard, Loading },
  mixins: [ mixinList ],
  props: {
    /*
     * isOpen: 開閉状態
     * selectedIds: 選択IDs
     * selectedItems: 選択データ
     */
    value: {
      type: Object,
      required: true,
      default: function () {
        return {
          isOpen: false,
          selectedIds: [],
          selectedItems: []
        }
      }
    },
    matchingAlgo: {
      type: String,
      required: false,
      default: '0',
      /**
       * 0: 前方一致
       * 1: 部分一致
       * 2: 完全一致
       */
      validate (value) {
        return this.isIncludes(['0', '1', '2'], value)
      }
    },
    maxSelect: {type: Number, required: false, default: 100000},
    searchDefaultName: {type: String, required: false, default: ''}
  },
  data: function () {
    return {
      nameSearchFilter: '',
      loadingPagination: true,
      loading: false,
      modalErrors: [],
      modalMessages: [],
      search_name: '',
      search_corporate_name: '',
      search_date_from: '',
      search_date_to: '',
      checkedItems: [],
      // 最新の名刺情報モーダル
      modalBcard: {
        isOpen: false,
        sidPerson: ''
      },
      maxlengths: {}
    }
  },
  watch: {
    'value.isOpen': function (newValue, oldValue) {
      // 開いたときの初期設定
      this.resetData()
      if (newValue && !oldValue) {
        // 選択済みアイテムがある場合、サーバーから情報を取得する
        if (this.value.selectedIds.length) {
          this._getInitList()
        }
      }
    }
  },
  created: function () {
    this.nameSearchFilter = this.matchingAlgo
    this.modalMessages = ['検索してください。']
    this.pagination.count = 0
    this.checkLimit = this.maxSelect
    this.maxlengths = this.loadMaxlengths('Bcards')
  },
  methods: {
    resetData: function () {
      this.loadingPagination = true
      this.list = []
      this.modalErrors = []
      this.modalMessages = []
      this.checkedIds = []
      this.search_name = this.searchDefaultName
      this.search_corporate_name = ''
      this.search_date_from = ''
      this.search_date_to = ''
    },
    search: function () {
      this.modalErrors = []
      this.modalMessages = []
      this.getList()
    },
    _getInitList: function (options) {
      const vm = this
      // API実行
      this.sendListRequest({
        repo: 'person',
        method: 'postSearch',
        params: {
          ids: this.value.selectedIds
        },
        silent: true, // #476 検索しなおし、ページ切替のときに選択済みのIDをリセットしないようにする
        onSuccess: function (response) {
          vm.checkAll(vm.list, true)
          if (vm.list.length !== vm.value.selectedItems.length) {
            vm.modalMessages = ['取得できないデータがありました。']
            for (let item of vm.value.selectedItems) {
              if (!vm.isIncludes(vm.checkedIds, item.id)) {
                vm.list.push(item)
                vm.checkedIds.push(item.id)
              }
            }
          }
        }
      })
    },
    /**
     * 一覧取得処理
     * @param Object options
     *          page: ページ番号
     */
    getList: function (options) {
      const vm = this
      options = options || {}
      this.loading = true
      this.loadingPagination = !options.viaPagination
      // API実行
      this.sendListRequest({
        repo: 'person',
        method: 'postSearch',
        params: {
          page: options.page || 1,
          search_name: this.search_name,
          search_name_strict: this.nameSearchFilter,
          search_corporate_name: this.search_corporate_name,
          search_date_from: this.search_date_from,
          search_date_to: this.search_date_to
        },
        silent: true, // #476 検索しなおし、ページ切替のときに選択済みのIDをリセットしないようにする
        onSuccess: function (response) {
          if (vm.list.length === 0) {
            vm.modalMessages = ['データがありません。検索条件を変えて再検索してください。']
          }
        },
        finally: function () {
          vm.loading = false
          vm.loadingPagination = false
        }
      })
    },
    selectAndClose: function () {
      this.$emit('input', {
        isOpen: false,
        selectedIds: this.checkedIds,
        selectedItems: this.checkedItems
      })
    },
    /**
     * 最新の名刺情報を表示する
     */
    openModalBcard: function (personId) {
      this.modalBcard.sidPerson = personId
      this.modalBcard.isOpen = true
    },
    /**
     * 現在表示中の一覧を選択中一覧に追加する
     */
    apendAll: function () {
      let list = []
      for (let item of this.checkedItems) {
        if (list.indexOf(item) < 0) {
          list.push(item)
        }
      }
      for (let item of this.list) {
        if (list.indexOf(item) < 0) {
          list.push(item)
        }
      }
      this.checkAll(list, true)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/ModalSelPerson.vue